import React from "react";
import { useTranslation } from "react-i18next";
import { BookOpenIcon } from "@heroicons/react/24/outline";
import { focusRing } from "../../pages/Exams/TestBuilder/ui";

const chipClass =
  "inline-flex min-w-0 max-w-[16rem] items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-600/20";

/**
 * Marks a question that is based on a passage ({uuid, name}). A button with `onClick`; plain text
 * otherwise (e.g. inside another button).
 */
export default function PassageChip({ passage, onClick, className = "" }) {
  const [t] = useTranslation();
  if (!passage?.uuid) return null;
  const title = t("passages.chip_title", { name: passage.name });
  const content = (
    <>
      <BookOpenIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span className="truncate">{passage.name}</span>
    </>
  );
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        title={title}
        aria-label={title}
        className={`${chipClass} transition duration-200 hover:bg-indigo-100 ${focusRing} ${className}`}
      >
        {content}
      </button>
    );
  }
  return (
    <span title={title} className={`${chipClass} ${className}`}>
      {content}
    </span>
  );
}
